module.exports = __webpack_public_path__ + "img/27.1740af4e.jpg";